import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { exportBotChat } from "../Redux/Actions/event";
import { downloadCSV } from "../Utils/commonFiles";

const ExportModal = ({ show, handleClose, chatbotId }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const today = new Date().toISOString().split("T")[0];

    const validateDates = (start, end) => {
        if (!start || !end) {
            return "Please select both start and end dates.";
        }
        if (start > today || end > today) {
            return "Dates cannot be in the future.";
        }
        if (start > end) {
            return "Start date cannot be after end date.";
        }
        return "";
    };

    const handleStartDateChange = (e) => {
        const value = e.target.value;
        setStartDate(value);
        setError(validateDates(value, endDate));
    };

    const handleEndDateChange = (e) => {
        const value = e.target.value;
        setEndDate(value);
        setError(validateDates(startDate, value));
    };

    const exportChat = async () => {
        const validationError = validateDates(startDate, endDate);
        if (validationError) {
            setError(validationError);
            return;
        }

        setLoading(true);

        const updatedValues = {
            start_date: startDate,
            end_date: endDate,
            chatbotId,
        };

        try {
            const res = await dispatch(exportBotChat(updatedValues));
            if (res.payload.status === 200 || res.payload.status === 201) {
                downloadCSV(`ChatBot_${chatbotId}`, res.payload.data);
                toast.success(res?.payload?.message || "Export successful");
                handleClose();
            } else {
                toast.error(res?.payload?.message || "Export failed");
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            className="con-firmation-modal"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className="border-none justify-content-center">
                <Modal.Title className="mt-3">Export Chat</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-0 text-center">
                <div className="mb-3">
                    <p className="mb-1">Start Date</p>
                    <input
                        type="date"
                        className="form-control w-75 mx-auto"
                        value={startDate}
                        onChange={handleStartDateChange}
                        max={today}
                    />
                </div>
                <div className="mb-3">
                    <p className="mb-1">End Date</p>
                    <input
                        type="date"
                        className="form-control w-75 mx-auto"
                        value={endDate}
                        onChange={handleEndDateChange}
                        max={today}
                    />
                    {error && <small className="text-danger d-block mt-2">{error}</small>}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-none justify-content-center">
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={exportChat}
                    disabled={!!error || !startDate || !endDate || loading}
                >
                    {loading ? <Spinner animation="border" size="sm" /> : "Export"}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ExportModal;
